var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74456 19.77L10.9762 16.5375C11.1325 16.3812 11.2202 16.1693 11.2202 15.9483C11.2202 15.7274 11.1325 15.5154 10.9762 15.3592C10.82 15.2029 10.608 15.1152 10.3871 15.1152C10.1661 15.1152 9.95417 15.2029 9.79789 15.3592L6.83373 18.3217L6.83373 1.33333C6.83373 1.11232 6.74593 0.900358 6.58965 0.744077C6.43337 0.587797 6.22141 0.5 6.00039 0.5V0.5C5.77938 0.5 5.56742 0.587797 5.41114 0.744077C5.25486 0.900358 5.16706 1.11232 5.16706 1.33333L5.16706 18.3725L2.15456 15.3592C2.07716 15.2817 1.98526 15.2202 1.88409 15.1783C1.78293 15.1363 1.67449 15.1148 1.56498 15.1148C1.45546 15.1148 1.34702 15.1363 1.24586 15.1783C1.14469 15.2202 1.05279 15.2817 0.975392 15.3592C0.819166 15.5154 0.731404 15.7274 0.731404 15.9483C0.731404 16.1693 0.819166 16.3812 0.975392 16.5375L4.20789 19.7708C4.67775 20.2383 5.31362 20.5006 5.9764 20.5005C6.63918 20.5003 7.27492 20.2377 7.74456 19.77Z",
    fill: "#FE273B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8acf5a9095158dcabdf757c6a03dd72e.svg";
export { ForwardRef as ReactComponent };